import { FormEvent, useEffect, useState } from "react";
import InputField from "../../components/form/input-field";
import { numberWithCommas } from "../../lib/helper-support";
import ApiSupport from "../../lib/api-support";
import { ErrorFlash, SuccessFlash } from "../../components/helper/flash-notification";
import SpinnerLoader from "../../components/loader/spinner-loader";

const SystemTransactionLimit = () => {
    const defaultLimits = [
        { id: 'bank_transfer', label: 'Bank transfer limit' },
        { id: 'airtime', label: 'Airtime limit' },
        { id: 'internet_data', label: 'Internet data limit' },
    ];

    const [limits, setLimits] = useState<any[]>([]);

    const getTransactionLimit = async () => {
        const request = await new ApiSupport().get('getTransactionLimit');

        if (request === 'error') {
            ErrorFlash('Something went wrong');
            return;
        }

        const fetchedData = JSON.parse(request).data;

        const updatedLimits = defaultLimits.map((item) => {
            const match = fetchedData.find((entry: any) => entry.type === item.id);
            return {
                ...item,
                day_limit: match?.day_limit ?? 0,
                night_limit: match?.night_limit ?? 0,
                amount_per_transaction: match?.amount_per_transaction ?? 0,
            };
        });

        setLimits(updatedLimits);
    };

    useEffect(() => {
        getTransactionLimit();
    }, []);

    const [loading, setLoading] = useState<any|null>(null)

    const updateLimit = async(index:number) => {
        
        const transactionLimit = limits[index]
        setLoading(transactionLimit.id)
        const request = await new ApiSupport().post(`setTransactionLimit`, {
            type: transactionLimit.id,
            day_limit: transactionLimit.day_limit,
            night_limit: transactionLimit.night_limit,
            amount_per_transaction: transactionLimit.amount_per_transaction
        });
        setLoading(null)

        if ( request === 'error' ){
            ErrorFlash('Error processing request, try again.');
            return;
        }
        SuccessFlash('System transaction limit updated successfully.');
    }

    const handleLimitChange = (index: number, key: string, value: string) => {
        const updated = [...limits];
        updated[index][key] = Number(value);
        setLimits(updated);
    };

    return (
        <div className="mt-10">
            <h3 className="text-[#2E384D] font-[700] text-[20px]">System transaction limit</h3>
            <div className="grid gap-4 mt-5">
                {limits.map((item, index) => (
                    <div key={index}>
                        <h3 className="text-[#2E384D] font-[700] text-[15px]">{item.label}</h3>
                        <div className="grid gap-4 md:grid-cols-2">
                            <div>
                                <InputField
                                    label="Day limit (6am to 11:59pm)"
                                    type="number"
                                    value={item.day_limit}
                                    onChangeInput={(e) => handleLimitChange(index, 'day_limit', e.target.value)}
                                />
                                <p className="font-[400] text-[12px] mt-1">
                                    {numberWithCommas(item.day_limit)}
                                </p>
                            </div>
                            <div>
                                <InputField
                                    label="Night limit (12am to 5:59am)"
                                    type="number"
                                    value={item.night_limit}
                                    onChangeInput={(e) => handleLimitChange(index, 'night_limit', e.target.value)}
                                />
                                <p className="font-[400] text-[12px] mt-1">
                                    {numberWithCommas(item.night_limit)}
                                </p>
                            </div>
                            <div>
                                <InputField
                                    label="Amount per transaction"
                                    type="number"
                                    value={item.amount_per_transaction}
                                    onChangeInput={(e) => handleLimitChange(index, 'amount_per_transaction', e.target.value)}
                                />
                                <p className="font-[400] text-[12px] mt-1">
                                    {numberWithCommas(item.amount_per_transaction)}
                                </p>
                            </div>
                        </div>
                        <button onClick={() => updateLimit(index)} disabled={loading} type="button" className="text-white space-x-2 bg-primary hover:bg-tertiary focus:ring-4 focus:outline-none  font-medium rounded-lg text-sm inline-flex items-center mt-4 px-5 py-2.5 text-center">
                            <span>Save changes</span>
                            {loading === item.id && <SpinnerLoader/>}
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SystemTransactionLimit;
